import authAxios from "../utils/authAxios";

const wordClient = {
    getWordsByDeckId: async (deckId, page = 0, size = 10) => {
        return await authAxios(`/api/words/deck/${deckId}?page=${page}&size=${size}`, {
            method: 'GET',
        });
    },

    getWordById: async (wordId) => {
        return await authAxios(`/api/words/${wordId}`, {
            method: 'GET',
        });
    },

    createWord: async (word) => {
        return await authAxios(`/api/words`, {
            method: 'POST',
            data: word,
        });
    },

    updateWord: async (wordId, word) => {
        return await authAxios(`/api/words/${wordId}`, {
            method: 'PUT',
            data: word,
        });
    },

    deleteWord: async (wordId) => {
        return await authAxios(`/api/words/${wordId}`, {
            method: 'DELETE',
        });
    },
};

export default wordClient;
